// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a75f0e19","330":"f2022186","404":"3b1ebc5d","498":"180e8cf9","805":"dd1ed198"}[chunkId] + ".chunk.js";
};